import React from "react";
import '../custom.css';

export function Footer(props) {
    return (
        <footer className={"mt-4 no-print"}>
            <div id="pe-footer" className="d-flex justify-content-center align-items-center py-4">
                {(props.step > 0 && props.planChoice === "isnp") &&
                    <div className="d-flex">
                        <div className="d-flex flex-column text-center">
                            <div className="d-flex justify-content-center">
                                <b>Tribute Select (HMO-POS I-SNP)</b>
                            </div>
                            <div className="d-flex justify-content-center">
                                PO Box 3630
                            </div>
                            <div className="d-flex justify-content-center">
                                Little Rock, AR 72202
                            </div>
                            <div className="d-flex justify-content-center">
                                Toll-free: 1-877-372-1033
                            </div>
                            <div className="d-flex justify-content-center">
                                (TTY 711)
                            </div>
                            <div className="d-flex">
                                <div className="d-flex flex-column text-center">
                                    <div className="d-flex d-inline-flex align-items-center">
                                        <a href="https://tributemedicare.com"
                                           className="text-secondary"
                                           target="_blank" rel="noopener noreferrer"
                                           title="Tribute Health Plans Home Page">Home Page</a>
                                        <span className={"footer-divider"}>|</span>
                                        <a className="text-secondary"
                                           href={"https://tributemedicare.com/privacy-information/"}
                                           target="_blank" rel="noopener noreferrer"
                                           title="Tribute Health Plans Privacy Policy">Privacy</a>
                                        <span className={"footer-divider"}>|</span>
                                        <a href={"https://tributemedicare.com/wp-content/uploads/2025/10/H1587_003ANTIDISCRIM26_C.pdf"}
                                           className="text-secondary"
                                           target="_blank"
                                           title="Tribute Health Plans Anti-Discrimination Notice"
                                           rel="noopener noreferrer">
                                            Anti-Discrimination Notice</a>
                                        <span className={"footer-divider"}>|</span>
                                        <a href={"https://tributemedicare.com/wp-content/uploads/2025/10/H1587_STAR26_M.pdf"}
                                           className="text-secondary"
                                           target="_blank"
                                           title="Medicare Star Rating" rel="noopener noreferrer">Medicare Star
                                            Rating</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                }
                {(props.step > 0 && props.planChoice === "dsnp") &&
                    <div className="d-flex">
                        <div className="d-flex flex-column justify-content-center">
                            <div className="d-flex justify-content-center">
                                <b>AIP Dual Advantage (HMO D-SNP)</b>
                            </div>
                            <div className="d-flex justify-content-center">
                                PO Box 3630
                            </div>
                            <div className="d-flex justify-content-center">
                                Little Rock, AR 72202
                            </div>
                            <div className="d-flex justify-content-center">
                                Toll-free: 1-866-488-5457
                            </div>
                            <div className="d-flex justify-content-center">
                                (TTY 711)
                            </div>
                            <div className="d-flex">
                                <div className="d-flex flex-column">
                                    <div className="d-flex d-inline-flex align-items-center">
                                        <a href={"https://aipadvantage.com/"}
                                           className="text-secondary"
                                           target="_blank" rel="noopener noreferrer"
                                           title="AIP Cares Plans Home Page">Home Page</a>
                                        <span className={"footer-divider"}>|</span>
                                        <a href={"https://aipadvantage.com/privacy-information/"}
                                           className="text-secondary"
                                           target="_blank" rel="noopener noreferrer"
                                           title="AIP Cares Plans Privacy Policy">Privacy</a>
                                        <span className={"footer-divider"}>|</span>
                                        <a href={"https://aipadvantage.com/wp-content/uploads/2025/10/H1587_001ANTIDISCRIM26_C-2.pdf"}
                                           target="_blank"
                                           className="text-secondary"
                                           title="AIP Cares Plans Anti-Discrimination Notice"
                                           rel="noopener noreferrer">
                                            Anti-Discrimination Notice</a>
                                        <span className={"footer-divider"}>|</span>
                                        <a href={"https://aipadvantage.com/wp-content/uploads/2025/10/H1587_STAR26_M.pdf"}
                                           className="text-secondary"
                                           target="_blank"
                                           title="Medicare Star Rating" rel="noopener noreferrer">Medicare Star
                                            Rating</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                }
            </div>
        </footer>
    );
}
